import type { SupportTicketRow } from '../../domain/support/types';
import { formatDate, formatDateTime } from '../../utils/formatters';
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableHeader,
    TableRow,
} from '../../components/ui/table';
import { TICKET_STATUS_LABELS } from './ticketStatusLabels';

interface SupportTicketListProps {
    items: SupportTicketRow[];
    onSelect: (id: string) => void;
}

export function SupportTicketList({ items, onSelect }: SupportTicketListProps) {
    if (items.length === 0) {
        return (
            <p className="py-12 text-center text-sm text-muted">
                Nenhum ticket encontrado. Crie um novo para falar com nossa equipe.
            </p>
        );
    }

    return (
        <Table>
            <TableHeader>
                <TableRow>
                    <TableHead>Assunto</TableHead>
                    <TableHead>Status</TableHead>
                    <TableHead>Atualizado em</TableHead>
                    <TableHead>Criado em</TableHead>
                </TableRow>
            </TableHeader>
            <TableBody>
                {items.map((row) => (
                    <TableRow
                        key={row.id}
                        className="cursor-pointer"
                        onClick={() => onSelect(row.id)}
                    >
                        <TableCell>
                            <span className="font-medium text-default">{row.subject}</span>
                        </TableCell>
                        <TableCell>{TICKET_STATUS_LABELS[row.status]}</TableCell>
                        <TableCell className="text-muted">{formatDateTime(row.updatedAt)}</TableCell>
                        <TableCell className="text-muted">{formatDate(row.createdAt)}</TableCell>
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    );
}
